<template>
  <el-card shadow="never"
            class="aui-card--fill">
    <el-form label-position="top"
             :model="dataForm"
             ref="dataForm">
      <div class="location-layout">
        <el-row class="row-mar-l">
          <!-- 业务编码 -->
          <el-col :span="6">
            <el-form-item :label="$t('businessData.bussinessTypeCode')">
              <el-input v-model="dataForm.bussinessTypeCode"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 业务名称 -->
          <el-col :span="6">
            <el-form-item :label="$t('businessData.bussinessTypeName')">
              <el-input v-model="dataForm.bussinessTypeName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 排序 -->
          <el-col :span="6">
            <el-form-item :label="$t('businessData.sort')">
              <el-input v-model="dataForm.sort"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </el-card>
</template>
<script>
export default {
  data () {
    return {
      dataForm: {}
    }
  },
  // 页面初始化
  activated () {
    this.$nextTick(() => {
      this.$refs['dataForm'].resetFields()
      if (this.$route.query.bussinessTypeId) {
        this.dataForm.bussinessTypeId = this.$route.query.bussinessTypeId
        this.getInfo()
      }
    })
  },
  methods: {
    // 获取信息
    getInfo () {
      this.$request.get(`/sys/commbusinessdata/info/${this.dataForm.bussinessTypeId}`).then((res, total, code, data) => {
        this.dataForm = {
          ...this.dataForm,
          ...data.result
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style type="text/css" scoped>
</style>
